import React, { Component, Fragment } from "react";
import { Modal } from "react-bootstrap";
import autoBind from "react-autobind";
import DDados from "../contadorContribuinte.ddados";
import { connect } from "@common/components/base.component";
import Form from "@common/externos/components/validation/form.validation";
import ContadorContribuinteForm from "./contadorContribuinte.form";

class Container extends Component {
  constructor(props) {
    super(props);
    autoBind(this);
  }

  render() {
    const { Campos, Titulo } = DDados;
    const { onSubmit, onCancel, openClose, state, onChange } = this.props;

    return (
      <Modal
        className={"mt-5 mb-5"}
        show={openClose}
        onHide={onCancel}
        enforceFocus={true}
        size="lg"
        backdrop="static"
      >
        <Modal.Header>
          <Modal.Title>
            <h3>{`Inclusão de ${Titulo}`}</h3>
          </Modal.Title>
        </Modal.Header>
        <Form
          onSubmit={onSubmit}
          onCancel={onCancel}
          boxForm
          removeWell={true}
          prefix={"I"}
          fromModal
        >
          <>
            <Modal.Body>
              <ContadorContribuinteForm state={state} onChange={onChange} />
            </Modal.Body>
          </>
        </Form>
      </Modal>
    );
  }
}

export default connect({})(Container);
